import { render } from "./User.vue?vue&type=template&id=dd92eb4e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/User.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd92eb4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd92eb4e', __exports__)) {
    api.reload('dd92eb4e', __exports__)
  }
  
  module.hot.accept("./User.vue?vue&type=template&id=dd92eb4e", () => {
    api.rerender('dd92eb4e', render)
  })

}


export default __exports__